<template>
  <div>
    <Modal title="绑定微信二维码" v-model="value" :mask-closable="false" width="360" footer-hide on-visible-change="visibleChange">
      <div slot="close">
        <Icon type="ios-close" size="31" color="#999" @click="cancel" />
      </div>
      <!-- <Alert>An info prompt</Alert> -->
      <div class="code-box">
        <Spin fix v-if="!imgLoaded"></Spin>
        <img v-if="QRImg&&!loadError" :src="QRImg" alt="" @load="handleImageLoad" @error="handleImageError" />
        <div v-if="loadError" class="error-tip">二维码加载失败</div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      QRImg: '',
      imgLoaded: false,
      loadError: false,
    }
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    // QRImg: {
    //     type: String,
    //     required: true
    // }
  },
  mounted() {
    this.imgLoaded = false
    this.loadError = false
    this.QRImg = `${this.$constDefinition.baseUrl}/cgbfile/previewSupplierUserQRcode/supplierWechatUserId?supplierWechatUserId=${this.id}`
  },
  methods: {
    init() {
      this.QRImg = `${this.$constDefinition.baseUrl}/cgbfile/previewSupplierUserQRcode/supplierWechatUserId?supplierWechatUserId=${this.id}`
    },
    handleImageLoad() {
      this.imgLoaded = true
    },
    handleImageError() {
      this.imgLoaded = true
      this.loadError = true
    },
    visibleChange(value) {
      if (!value) {
        this.$emit('close', value)
      }
    },
    cancel() {
      this.$emit('close', false)
    },
  },
}
</script>

<style lang="less" scoped>
.code-box {
  height: 260px;
  display: flex;
  justify-content: center;
  align-items: center;
  //   flex-direction: column;
  img {
    width: 200px;
  }
}
</style>
